import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-header-container',
  templateUrl: './header-container.component.html',
  styleUrls: ['./header-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderContainerComponent {
  constructor() {}
}
